import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { useLang } from "../i18n";

export default function Footer({ content }) {
  const { t, lang } = useLang();
  return (
    <footer className="relative z-10 bg-[#050505] border-t border-white/10 py-14">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div>
            <img src={content.logo_url} alt={content.business_name} className="h-14 w-auto object-contain mb-4" />
            <p className="font-body text-neutral-500 max-w-sm">{t.footer.tagline}</p>
          </div>
          <div className="flex flex-col gap-3 font-body">
            <a href={`tel:${content.phone.replace(/[^0-9]/g, "")}`} className="flex items-center gap-2 text-white hover:text-primary-red transition-colors">
              <Phone size={16} className="text-primary-red" /> {content.phone}
            </a>
            <span className="flex items-center gap-2 text-neutral-400">
              <MapPin size={16} className="text-primary-red" /> {content.address}, {content.city}
            </span>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <span className="font-mono2 text-xs text-neutral-600">
            © {new Date().getFullYear()} {content.business_name}. {t.footer.rights}
          </span>
          <Link to="/admin/login" className="font-mono2 text-xs uppercase text-neutral-600 hover:text-primary-red transition-colors" data-testid="footer-admin">
            {t.nav.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
}
